module.exports = __webpack_public_path__ + "static/media/line-big.4e1424ba.gif";